import * as yup from 'yup';

// Password: min 8, at least 1 uppercase, 1 special character
const passwordRegex = /^(?=.*[A-Z])(?=.*[^A-Za-z0-9]).{8,}$/;

export const signupSchema = yup.object({
  email: yup
    .string()
    .trim()
    .email('Invalid email address')
    .required('Email is required'),
  mobileNumber: yup
    .string()
    .required('Mobile number is required')
    .min(10, 'Mobile number is invalid'),
  password: yup
    .string()
    .required('Password is required')
    .matches(passwordRegex, 'Password must be 8+ chars, 1 uppercase, 1 special'),
  agreeToNotifications: yup
    .boolean()
    .oneOf([true], 'You must agree to receive notifications from CricCenter')
    .required(),
});

export type SignupFormValues = yup.InferType<typeof signupSchema>;
